
  var _styles = {
  "privilege-container": {
    "width": "5.89333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginTop": "0.16rem"
  },
  "privilege-label-container": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "minWidth": "0.37333rem",
    "height": "0.37333rem",
    "borderRadius": "0.4rem",
    "marginRight": "0.06667rem"
  },
  "privilege-label": {
    "marginLeft": "0.05333rem",
    "marginRight": "0.05333rem",
    "marginBottom": "0.01333rem",
    "paddingTop": "0.06667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(34,34,34)",
    "textAlign": "center",
    "lineHeight": "0.29333rem"
  },
  "privilege-desc": {
    "flex": 1,
    "paddingTop": "0.06667rem",
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(102,102,102)",
    "textAlign": "justify",
    "lineHeight": "0.33333rem"
  }
};



  module.exports = _styles;
  